import { Directive, EventEmitter, HostListener, inject, Output, input } from '@angular/core';
import { Router } from '@angular/router';
import { CallbackService } from '@library/utils/services/callback.service';
import { UserAgentService } from '@library/utils/services/user-agent.service';

@Directive({
  selector: '[url]',
  standalone: false,
})
export class LinkUrlDirective {
  private readonly router = inject(Router);
  userAgent = inject(UserAgentService);
  private readonly callback = inject(CallbackService);

  /**
   * Url to go to
   */
  readonly url = input<string>(undefined);

  /**
   * Should open in browser or not
   */
  readonly inBrowser = input(false);

  /**
   * Event emitted when the link is clicked
   */
  @Output() navigate = new EventEmitter();

  @HostListener('click') goTo() {
    const url = this.url();
    if (typeof url === 'undefined') {
      return;
    }

    if (!this.inBrowser()) {
      if (url.startsWith('http')) {
        window.location.href = url;
      }
      else {
        this.router.navigateByUrl(url);
      }
    }
    else if (this.userAgent.isNativeApp()) {
      this.callback.call(this.callback.list.openInBrowser, { url: url, exit: false });
    }
    else {
      window.open(url, '_blank');
    }
  }
}
